import { render, staticRenderFns } from "./ConsultaDaps.vue?vue&type=template&id=c80e9540&scoped=true&"
import script from "./ConsultaDaps.vue?vue&type=script&lang=js&"
export * from "./ConsultaDaps.vue?vue&type=script&lang=js&"
import style0 from "./ConsultaDaps.vue?vue&type=style&index=0&id=c80e9540&scoped=true&lang=css&"
import style1 from "../assets/css/consultaDaps.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80e9540",
  null
  
)

export default component.exports